import { useAuthStore } from '@/stores/authStore'
import { Link } from 'react-router-dom'

export function AuthHeader() {
  const user = useAuthStore((s) => s.user)

  return (
    <header className="sticky top-0 z-10 border-b border-border bg-background/80 backdrop-blur-sm">
      <div className="mx-auto flex max-w-sm items-center px-4 py-3">
        <Link
          to={user ? '/dashboard' : '/'}
          className="text-lg font-heading font-black tracking-tight hover:opacity-80 transition-opacity"
        >
          RoleRound
        </Link>
      </div>
    </header>
  )
}
